import './index.scss';
import Router from './router';
import React from 'react';
// import GlobalStateProvider './service/global-state';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
const GlobalStateProvider = React.lazy(() => import('./service/global-state'))

function App() {
  return (
    <I18nextProvider i18n={i18n}>
    <GlobalStateProvider>
      <div className="App">
        <Router />
        <ToastContainer autoClose={3000}/>
      </div>
    </GlobalStateProvider>
    </I18nextProvider>
  );
}

export default App;
